// First we need to import axios.js
import axios from 'axios';
import {store2} from './index'
import { notifyError } from './Utils/CustomNotifcations';

const baseUrl =  `${window.location.protocol}//${window.location.host}`||"";
let isSessionExpired=false
const instance = axios.create({
   baseURL:baseUrl,
    withCredentials: true,
});


instance.interceptors.request.use(request => {

    return request;
}, error => {
    // return Promise.reject(error);
    console.error(error)
});
instance.interceptors.response.use(response => {
      const contentType = response.headers['content-type'];
    if (response.config.responseType === 'blob' || contentType?.includes('application/octet-stream') || contentType?.includes('application/pdf')) {
      return response;
    }
    if(response.config.singleReturn){
        return response
    }

    if(response.data.status === 'success' || response.data.status === 'ambiguous'){
        return response;
    }else{
        // return response.data;
        return Promise.reject( response.data);
    }
}, error => {
     const status = error?.response?.status;
    const currentPath = window.location.pathname;
    const skipRoutes = ["/login", "/logout"];
    if (
      status === 401 &&
      !skipRoutes.includes(currentPath) 
    ) {
  if (!isSessionExpired) {
    isSessionExpired = true;

    store2.dispatch(notifyError("Session expired. Please login again."));

    setTimeout(() => {
      localStorage.clear();
      sessionStorage.clear();
      window.location.replace("/logout");
      isSessionExpired = false;
    }, 2000);
  }
    }
    return Promise.reject(error);
});


export default instance;